import React from 'react';
import styled from '@emotion/styled';
import IconMenu from 'images/icons/liscio-logo-small.svg?react';

const StyledIcons = styled.span``;

const LiscioLogo = () => (
  <StyledIcons className="button-icon">
    <IconMenu width="1rem" />
  </StyledIcons>
);

export default LiscioLogo;
